// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__lFWeq","formItem":"Form_formItem__KWiQs","label":"Form_label___FjCr"};